(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('hero-video');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {
         
           document.body.style.overflow = 'hidden'; 
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('ed-video');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {

           document.body.style.overflow = 'hidden';
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["previou-events-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('backgroundVideo');
    const muteButton = document.getElementById('mute-toggle');
    console.log(video)
    // Mute button click event listener
    muteButton.addEventListener('click', function() {
      if (video.muted) {
        video.muted = false;
        muteButton.textContent = '🔇Mute';  // Change button text
      } else {
        video.muted = true;
        muteButton.textContent = '🔊Unmute';  // Change button text
      }
    });
  });

   document.addEventListener("DOMContentLoaded", () => {
      const gmTarget = document.querySelector('.gm-target');

      if (gmTarget) {
        gmTarget.addEventListener('mouseenter', () => {

           document.body.style.overflow = 'hidden';
        });

        gmTarget.addEventListener('mouseleave', () => {
           document.body.style.overflow = 'auto' // Disable scrolling
        });
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siroy-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.siroyHeroReady === 'true') return;
      root.dataset.siroyHeroReady = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.siroy-hero__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-siroy-hero-dot]'));
      if (slides.length < 2) return;

      var index = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
      var timer = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goTo(next) {
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        if (dots[index]) {
          dots[index].classList.remove('is-active');
          dots[index].removeAttribute('aria-current');
        }

        index = (next + slides.length) % slides.length;

        slides[index].classList.add('is-active');
        slides[index].removeAttribute('aria-hidden');
        if (dots[index]) {
          dots[index].classList.add('is-active');
          dots[index].setAttribute('aria-current', 'true');
        }
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (!autoplay || reduceMotion) return;
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, speed);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-siroy-hero-dot'), 10);
          if (isNaN(target) || target === index) return;
          goTo(target);
          start();
        });
      });

      /* Mobile / touch: swipe left = next, swipe right = previous */
      var touchStartX = 0;
      var touchStartY = 0;
      var touchActive = false;
      var swipeLocked = false;

      function onTouchStart(event) {
        if (!event.touches || event.touches.length !== 1) return;
        if (event.target.closest && event.target.closest('a, button')) return;
        touchActive = true;
        swipeLocked = false;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        stop();
      }

      function onTouchMove(event) {
        if (!touchActive || swipeLocked || !event.touches || !event.touches.length) return;
        var dx = event.touches[0].clientX - touchStartX;
        var dy = event.touches[0].clientY - touchStartY;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
          swipeLocked = true;
        }
      }

      function onTouchEnd(event) {
        if (!touchActive) return;
        touchActive = false;
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) {
          start();
          return;
        }
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        var threshold = 45;
        if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(index + 1);
          else goTo(index - 1);
        }
        start();
      }

      root.addEventListener('touchstart', onTouchStart, { passive: true });
      root.addEventListener('touchmove', onTouchMove, { passive: true });
      root.addEventListener('touchend', onTouchEnd, { passive: true });
      root.addEventListener('touchcancel', function () {
        touchActive = false;
        start();
      }, { passive: true });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      start();
    }

    function boot() {
      document.querySelectorAll('[data-siroy-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target && event.target.querySelector
        ? event.target.querySelector('[data-siroy-hero]') || event.target
        : null;
      if (section && section.hasAttribute && section.hasAttribute('data-siroy-hero')) {
        section.dataset.siroyHeroReady = 'false';
        initHero(section);
      } else {
        boot();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
